import Button from 'ui/Button';
import EmptyState from 'ui/EmptyState';

import { initialTeamSettings, useTeamContext } from '../../utils/team';

const CreateBrandingIntro: React.FC = () => {
  const { saveSettings, isSaving } = useTeamContext();
  return (
    <EmptyState
      icon="palette"
      title="Add your own branding"
      description="Save your brand colors, making them readily available when working on your diagrams."
      px={0}
      pt={0}
      h="100%"
    >
      <Button
        variant="primary-solid"
        onClick={() => saveSettings(initialTeamSettings)}
        loading={isSaving}
      >
        Create corporate branding
      </Button>
    </EmptyState>
  );
};

export default CreateBrandingIntro;
